"use strict";

jQuery.noConflict();
(function($){

    $(document).ready(function(){


        var $window = $(window);
        var $body = $('body');
        var $htmlBody = $('html, body');
        var $main = $('#main');
        var $footer = $('#footer');
        var $header = $('#header');

        var backgroundSize = (typeof(Modernizr) !== 'undefined') ? Modernizr.backgroundsize : false;

        var windowWidth = $window.width();
        var windowHeight = $window.width();
        var viewableHeight = 0;

        var palmBreakpoint = 570;//480;
        var lapBreakpoint = 1023;
        var ignoreResize = false;
        var isDesk;
        var isLap;
        var isPalm;
        var hasTouch = (typeof(Modernizr) !== 'undefined' && typeof(Modernizr.touch) !== undefined) ? Modernizr.touch : false;
        var isRetina = (typeof(Modernizr) !== 'undefined') ? Modernizr.highres : false;
        var retinaSizeBuffer = 40;



      /***************************
       *
       *  EXTERNAL LINKS
       *
       ***************************/

      $('a[rel="external"]').attr('target', '_blank');

        $("#mobile-menu").mmenu({
            
            position:'right'
            
         });

        $(".slider").owlCarousel({
 
              //navigation : true, // Show next and prev buttons
              slideSpeed : 300,
              pagination : true,
              singleItem : true,
              navigation: true,
              navigationText : ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
              autoPlay: true,
              mouseDrag: false,
         
              // "singleItem:true" is a shortcut for:
              // items : 1, 
              // itemsDesktop : false,
              // itemsDesktopSmall : false,
              // itemsTablet: false,
              // itemsMobile : false
         
          });




        var $grid = $('.row--content-grid-archive').isotope({
                itemSelector: '.grid__item'
              });


                // layout Isotope after each image loads
                $grid.imagesLoaded().progress( function() {
                  $grid.isotope('layout');
                });

                // change is-checked class on buttons
              $('.button-group').each( function( i, buttonGroup ) {
                var $buttonGroup = $( buttonGroup );
                $buttonGroup.on( 'click', 'button', function() {

                    //if($(this).hasClass('is-all')) {

                    //    $buttonGroup.find('.is-checked').not('.is-all').removeClass('is-checked');
                    //    $( this ).addClass('is-checked');

                   // } else {

                   //     $buttonGroup.find('.is-all').removeClass('is-checked');

                   //     if($(this).hasClass('is-checked')) {
                    //        $(this).removeClass('is-checked');
                    //    } else {
                   //         $( this ).addClass('is-checked');
                   //     }
                  //  }

                  $buttonGroup.find('.is-checked').removeClass('is-checked');
                  $( this ).addClass('is-checked');
                        
                  
                  
                });
              });
              
              // bind filter button click
              $('.filters-button-group').on( 'click', 'button', function() {
                var filters = [];
                $('.filters-button-group .button').filter('.is-checked').each(function(){

                  filters.push( $(this).attr('data-filter') );
                 // alert('howdy');

                });
                
                filters = filters.join(', ');
                //filters = filters.join('');
                $grid.isotope({ filter: filters });


                //var filterValue = $( this ).attr('data-filter');
                // use filterFn if matches value
                //filterValue = filterFns[ filterValue ] || filterValue;
                //$grid.isotope({ filter: filterValue });
              });


              $('.venobox').venobox({
                  frameheight: 'auto',
                  framewidth: '940px'
              }); 

        


      /***************************
       *
       *  FANCYBOX
       *
       ***************************/

      function fancyBoxOpenCloseEffect() {
        return (!isPalm) ? 'elastic' : 'none';
      }

      function fancyBoxNextPrevEffect() {
        return (!isPalm) ? 'elastic' : 'none';
      }

      $('.fancybox').fancybox({
        padding: 0,
        margin: (!isPalm) ? 20 : 0,
        openEffect: fancyBoxOpenCloseEffect(),
        closeEffect: fancyBoxOpenCloseEffect(),
        nextEffect: fancyBoxNextPrevEffect(),
        prevEffect: fancyBoxNextPrevEffect(),
        caption: {
          type: 'inside'
        },
        tpl: {
          closeBtn: '<a title="Close" class="fancybox-item fancybox-close sprite sprite--close" href="javascript:;"></a>',
          next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span class="sprite sprite--next"></span></a>',
          prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span class="sprite sprite--prev"></span></a>'
        }
      });


      // Small form window
      $('.fancybox-form-window').fancybox({
        wrapCSS: 'form-window',
        padding: 0,
        openEffect: 'fade',
        closeEffect: 'fade',
        minWidth: ($window.width() < 400) ? $window.width() : 400,
        maxWidth: ($window.width() < 400) ? $window.width() : 400,
        maxHeight: ($window.height() < 480) ? 9999 : 480,
        margin: (isPalm) ? 0 : 20,
        autoSize: isPalm,
        autoResize: true,
        tpl: {
          closeBtn: '<a title="Close" class="fancybox-item fancybox-close sprite sprite--close" href="javascript:;"></a>'
        }
      });


      

      /***************************
         *
         *  RESPONSIVE IMAGES
         *  Based on the image having data-2x (and other) data attributes and the 'responsive' class
       *  Eg <img src="path/to/standard/image" class="responsive" data-width="width_of_standard_image" data-height="height_of_standard_image" data-2x="path/to/2x/image" data-2x_width="width_of_2x_image" data-2x_height="height_of_2x_image" />
         *
         ***************************/

        var $responsiveImage;
        var retinaSrc;
        var retinaSrcWidth;
        var retinaSrcHeight;
        var standardSrcWidth;
        var standardSrcHeight;
        var responsiveImageWidth;
        var responsiveImageHeight;
        var retinaSrcRequired;

        $('img.responsive').each(function(){
            $responsiveImage = $(this);
            retinaSrc = $responsiveImage.data('2x');
            retinaSrcWidth = $responsiveImage.data('2x_width');
            retinaSrcHeight = $responsiveImage.data('2x_height');
            standardSrcWidth = $responsiveImage.data('width');
            standardSrcHeight = $responsiveImage.data('height');
            responsiveImageWidth = $responsiveImage.width();
            responsiveImageHeight = $responsiveImage.height();

            // retina src may not even be required, depending on the current size of the image wrapper element
            // the standard image may not be at 100%
            // we've got a buffer of 40px in determining if we even need to use retina src to still get "retina" display
            retinaSrcRequired = ((responsiveImageWidth * 2) > (standardSrcWidth + retinaSizeBuffer));

            if (retinaSrc && isRetina && retinaSrcRequired) {
                $responsiveImage.attr('src', retinaSrc);
            }
        });

          function fixme() {
           var $window = $(window);
           var nav = $('.header--fixed');
           if ($window.scrollTop() >= 200) {
              nav.addClass('fix-me');
            }
            $window.scroll(function(){
                if ($window.scrollTop() >= 200) {
                   nav.addClass('fix-me');
                }
                else {
                  if ($(window).width() > 980) {
                   nav.removeClass('fix-me');
                 }
                }
            });
              if ($(window).width() < 980) {
                  nav.addClass('fix-me');
              } else {
                  nav.removeClass('fix-me');
              }
          }

          




      /***************************
         *
         *  RESPONSIVE / BREAKPOINTS
         *
         ***************************/

        function resizeTasks() {
            // Check breakpoints
            windowWidth = $window.width();
            windowHeight = $window.height();
            viewableHeight = windowHeight - ( $footer.height() + $header.height() );
            isPalm = (windowWidth <= palmBreakpoint);
            isLap = (windowWidth > palmBreakpoint && windowWidth <= lapBreakpoint);
            isDesk = (windowWidth > lapBreakpoint);

            if (!ignoreResize) {
              // if you have any functions that need to be (re)run on every window resize, call them here
                fixme();
            }
        }

        $window.on('resize', debounce(resizeTasks, 100));
        $window.trigger('resize');

      $window.on('load', resizeTasks);

    });


})(jQuery);
